import React from 'react'
import './index.scss'
import { isFunc, getImgUrl, showAmount, showDiscount, hbsBoolean, getLinkUrl, i18n } from '../../common/util'

export default function renderItem(item, lang, focusCallback) {
    return <li className="home-list-item" key={item.goodsId} onMouseEnter={isFunc(focusCallback) ? () => focusCallback(item) : null}>
        <a target="_blank" href={getLinkUrl(`/p/${item.goodsId}.html`)}>
            <img alt="商品图片" className="home-list-item-img" src={getImgUrl(item.imgUrl)}></img>
            <div className="home-list-item-info">
                <span className="right price">&yen;{showAmount(item.salePrice)}</span>
                {
                    hbsBoolean(item.primePrice) && <span className="right op">&yen;{showAmount(item.primePrice)}</span>
                }
                {
                    hbsBoolean(item.primePrice) && <span className="right discount">{showDiscount(item.salePrice, item.primePrice)}</span>
                }
                <p className="name">{i18n(item.name, lang)}</p>
                <p className="des">{i18n(item.desc, lang)}</p>
                <div className="home-list-item-tags">
                    {
                        item.tags && item.tags.map(t => (<span className="home-list-item-tag" key={t.tagId}>{i18n(t.name, lang)}</span>))
                    }
                </div>
            </div>
        </a>
    </li>
}
